import { cn } from "@/lib/utils";

type TypographyTag = "p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
const baseTypographyClasses =
  "font-heading text-base antialiased text-foreground";

export const Typography = ({
  tag,
  children,
  className,
}: {
  tag: TypographyTag;
  children: React.ReactNode;
  className?: string;
}) => {
  switch (tag) {
    case "p":
      return (
        <p
          className={cn(baseTypographyClasses, "font-body text-sm", className)}
        >
          {children}
        </p>
      );
    case "span":
      return (
        <span
          className={cn(
            baseTypographyClasses,
            "font-heading text-sm font-medium",
            className
          )}
        >
          {children}
        </span>
      );
    case "h1":
      return (
        <h1
          className={cn(baseTypographyClasses, "text-2xl font-bold", className)}
        >
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2
          className={cn(
            baseTypographyClasses,
            "text-xl font-semibold",
            className
          )}
        >
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3
          className={cn(baseTypographyClasses, "text-lg font-bold", className)}
        >
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4
          className={cn(
            baseTypographyClasses,
            "text-base font-bold",
            className
          )}
        >
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5
          className={cn(
            baseTypographyClasses,
            "text-xs font-semibold tracking-wide",
            className
          )}
        >
          {children}
        </h5>
      );
    case "h6":
      return (
        <h6
          className={cn(
            baseTypographyClasses,
            "font-heading text-[12px] font-semibold text-foreground-secondary",
            className
          )}
        >
          {children}
        </h6>
      );
  }
};
